/**
/**
 * ProgramController
 * Responsible for Processing front end Programs
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */

angular.module('flsControllers').controller('ProgramController', [
    '$scope',
    'Program',
    function($scope, Program){

    // Define default Program Object
    // ...maybe this needs to be a factory?
    var defaultModel = {
        presentation_topics:[],
        presentations:[],
        primary_brand:{},
        primary_presentation:{},
        program_type:{},
        speaker_bureau:{},
        speakers:[],
    };

    // for #Create this would be {}
    // for #Edit this would be loaded Resource
    $scope.program = defaultModel

    // Set loading state to false
    $scope.loading = false

    // Init Secondary Presentations
    $scope.secondaryPresentations = []

    // List possible parents
    $scope.parents = []

    /**
     * Reset the Entity
     *
     * @return Void
     */
    $scope.reset = function() {
      // Re-map the Program to default
      $scope.program = defaultModel
      // Populate the secondary Presentations with Program presentations
      $scope.secondaryPresentations = defaultModel.presentations.map(function(item){return item["id"];});
    }

    /**
     * Init the Controller by fetching the properties of the Program
     *
     * @param  object profileId
     * @return Void
     */
    $scope.init = function(id){
        if (!id) return;
        // Set Loading to true
        $scope.loading = $scope.loading || true;
        // Load the Program
        Program.get({id:id}, function(resource){
            if(resource){
                // Rewrite default property
                defaultModel = resource.data || defaultModel
                // Set Loading to false
                $scope.loading = false;
                // reset the Program
                $scope.reset()
                // If draft, allow date change
                if(defaultModel.program_status_id == 1) {
                    $scope.applyDateLimits(defaultModel.program_type)
                }
                // Flash a message
                $.publish('resource.success', 'Program Loaded');
            } else {
                /*display an error maybe? */
            };
        }, function($error){
            _.each($error.data, function(error){
                $.publish('resource.error', error);
            });
        });
    }

    /**
     * True if the program can be submitted
     *
     * @return boolean
     */
    $scope.canBeSubmitted = function() {
        return true;
    }

    /**
     * True if the program can not be submitted
     *
     * @return boolean
     */
    $scope.cannotBeSubmitted = function() {
        return _.isEmpty($scope.program.program_type) || this.exceedsMaxAllowedTopics();
    }

    /**
     * True if we can proceed with the Draft
     *
     * @return Boolean
     */
    $scope.canBeDrafted = function() {
        // No Program Type
        if (_.isEmpty(this.program.program_type)) {
            return false;
        }
        // Below topics
        if (this.rule('allow_topic_selection') && this.belowMinAllowedTopics()) {
            return false;
        }
        // Above
        if (this.rule('allow_topic_selection') && this.exceedsMaxAllowedTopics()) {
            return false;
        }

        return true;
    }

    /**
     * True if we cannot proceed with the Draft
     *
     * @return Boolean
     */
    $scope.cantBeDrafted = function() {
        return ! this.canBeDrafted();
    }

    /**
     * True if the program planner exceeds the number of topics allowed
     *
     * @return boolean
     */
    $scope.belowMinAllowedTopics = function() {
        // Rule could be 0 or null
        let rule = this.rule('min_required_topics')
        // ANyway
        if (rule) {
            return $scope.hasPresentationTopics() && $scope.optionalProgramTopics().length < rule;
        }

        return false;
    }

    /**
     * True if the program planner exceeds the number of topics allowed
     *
     * @return boolean
     */
    $scope.exceedsMaxAllowedTopics = function() {
        // Rule could be 0 or null
        let rule = this.rule('max_required_topics')
        // ANyway
        if (rule) {
            return $scope.hasPresentationTopics() && $scope.optionalProgramTopics().length > rule;
        }

        return false;
    }

    /**
     * Select the program topics inherited from Presentation, filtering our  always selected topics (like ISI)
     *
     * @return array
     */
    $scope.optionalProgramTopics = function() {
        return _.filter($scope.program.presentation_topics, {'is_always_selected':false});
    }

    /**
     * True if program has presentation topics
     *
     * @return {Boolean}
     */
    $scope.hasPresentationTopics = function() {
        return ! _.isEmpty($scope.getPresentationTopics());
    }

    /**
     * Get Presentation topics from Primary Presentation
     *
     * @return array
     */
    $scope.getPresentationTopics = function() {
        return _.get($scope.program.primary_presentation, 'topics', []);
    }

    /**
     * Allow iterating through the list of values
     *
     * @param int start
     * @param int end
     */
    $scope.range = function(start, end) {
        var result = [];

        for (var i = start; i <= end; i++) {
            result.push(i);
        }

        return result;
    };

    /**
     * Compute Speaker Bureaud
     *
     * @type {Array}
     */
    $scope.speakerBureaus = function() {
        /* Define */
        var speakerBureaus = _.get(this.program, 'primary_brand.speaker_bureaus', []);
        /* Take only Valid and Future*/
        speakerBureaus = _.filter(speakerBureaus, function(o) {
            return o.is_valid || o.is_future;
        });
        /* Take only Active */
        speakerBureaus = _.filter(speakerBureaus, 'is_active');
        /* Push*/
        if (this.program.speaker_bureau_id || false) {
            speakerBureaus = _.chain(speakerBureaus)
                            .union([this.program.speaker_bureau])
                            .uniqBy('id')
                            .value();
        }
        /* Return */
        return speakerBureaus;
    }

    /**
     * Get the parents, if the rule allows it
     *
     * @return promise
     */
    $scope.fetchParents = function(query) {
        // Set Loading to true
        $scope.loading = true;
        /* Fetch possible parents from API */
        Program.get(query)
               .$promise
               .then(function(resource){
                    /* Set Profile*/
                    $scope.parents = resource.data;
                    /* Publish a message */
                    $.publish('resource.success', 'Parent Programs Loaded');
                    /* replace loader */
                    $scope.loading = false;
                })
               .catch(function($error){
                    _.each($error.data, function(error){
                        $.publish('resource.error', error);
                    });
               });
    }

    /**
     * Return all parent and the current one
     *
     * @return array
     */
    $scope.possibleParents = function() {
        /* List parents*/
        var parents = $scope.parents;
        /* get the current, if defined*/
        if (this.program.parent_program || false) {
            parents = _.chain(parents)
                       .union([this.program.parent_program])
                       .uniqBy('id')
                       .sortBy('label')
                       .value();
        }
        /* return */
        return parents;
    }

    /**
     * Scope the program types by the speaker bureau relation, if present
     *
     * @type {Array}
     */
    $scope.programTypes = function(){
        // get the program types
        var programTypes = _.get(this.program, 'primary_brand.active_program_types', []);
        // get speaker bureau
        var speakerBureau = _.get(this.program, 'speaker_bureau', {});
        // resolve specific types
        var scopedTypes = _.get(speakerBureau, 'program_types', []);
        // selected, scope out
        if (scopedTypes.length > 0) {
            programTypes = _.intersectionBy(programTypes, scopedTypes, 'id');
        }
        return _.sortBy(programTypes, 'label');
    }

    /**
     * List all Program Speakers
     *
     * @type {Array}
     */
    $scope.speakers = function(){
        return _.get(this, 'program.speakers', []);
    }

    /**
     * Get the value of a planning rule
     *
     * @param  {string} $rule
     * @param  {mixed}  $default
     * @return {mixed}
     */
    $scope.rule = function($rule, $default = null) {
        return _.get(this.rules(), $rule, $default);
    }

    /**
     * Get the value of a planning rule
     *
     * @param  {string} $rule
     * @return {mixed}
     */
    $scope.rules = function() {
        return _.get(this.program, 'program_type.planning_rules', []);
    }

    /**
     * I do not like the hacing involved.
     *
     * @return {Boolean}
     */
    $scope.isAudienceTypeVisible = function(){

        var isAudienceTypeVisible = this.rule('allow_audience_selection');

        if (isAudienceTypeVisible) {
            // List all possible checkboxes
            var $availableCheckboxes = $('input:checkbox[data-checkbox-at-least-one]');

            // List all checkboxes
            var $requiredCheckboxes = $availableCheckboxes.filter('[required]');

            // List all checkboxes
            var $checkedCheckboxes = $availableCheckboxes.filter(':checked');

            // Toggle Reuqired
            var toggleRequired = function(){
                if($requiredCheckboxes.is(':checked')) {
                    $requiredCheckboxes.removeAttr('required');
                } else {
                    $requiredCheckboxes.attr('required', 'required');
                }
            };

            // if at least is checked, we can remove unchecked
            if ($checkedCheckboxes.length > 0){
                $requiredCheckboxes.not($checkedCheckboxes).removeAttr('required');
            }

            // On change
            $requiredCheckboxes.change(toggleRequired);
        }

        return isAudienceTypeVisible;
    }

    /**
     * Populate the presentations list
     *
     * @return {}
     */
    $scope.presentations = function()
    {
        if(_.get(this.program, 'program_type.presentations', []).length === 1) {
            $scope.program.primary_presentation = _.get(this.program, 'program_type.presentations', [])[0];
        }
        return _.get(this.program, 'program_type.presentations', []);

    }

    /**
     * True if the we can make a presentaiton selection
     *
     * @return {Boolean}
     */
    $scope.hasPresentations = function()
    {
        return ! _.isEmpty(this.presentations());
    }

    /**
     * Build the range for the attendee_count_hcp
     *
     * @return array
     */
    $scope.attendeeCountHcpRange = function()
    {
        // Define the range
        var range = this.range(this.rule('min_invited_hcps'), this.rule('max_invited_hcps'));
        // push element to it
        range.push(this.program.attendee_count_hcp)
        // Chain the range to reject empty values, return sorted
        // Chain the range to reject empty values, return sorted
        return this.sortUnique(range)
    }

    /**
     * Build the range for the attendee_count_hcp
     *
     * @return array
     */
    $scope.attendeeCountFieldpRange = function()
    {
        // Define the range
        var range = this.range(this.rule('min_invited_fields'), this.rule('max_invited_fields'));
        // push element to it
        range.push(this.program.attendee_count_field)
        // Chain the range to reject empty values, return sorted
        return this.sortUnique(range)
    }

    /**
     * Sort and Unique an array
     *
     * @param  {Array} $range
     * @return {Array}
     */
    $scope.sortUnique = function(range)
    {
        return _.chain(range)
                .flatten()
                .reject(i => _.isUndefined(i))
                .sortBy(parseInt)
                .sortedUniqBy(parseInt)
                .value();
    }

    /**
     * True if there is a parent and the rule says we have to
     *
     * @return true
     */
    $scope.useParentDates = function()
    {
        return this.rule('parent_type_id') && this.rule('replicate_parent_dates');
    }

    /**
     * True if there is a parent and the rule says we have to
     *
     * @return true
     */
    $scope.useParentPresentation = function()
    {
        return this.rule('parent_type_id') && this.rule('replicate_parent_presentation');
    }

    /**
     * True if there is a parent and the rule says we have to
     *
     * @return true
     */
    $scope.hasWebcastUrl = function()
    {
        return this.rule('has_webcast_url') || _.get(this.program, 'webcast.url');
    }

    /**
     * True if there is a parent and the rule says we have to
     *
     * @return true
     */
    $scope.replicateParentWebcastUrl = function()
    {
        return this.rule('parent_type_id') && this.rule('replicate_parent_webcast_url');
    }

    /**
     * Apply date limits as needed
     */
    $scope.applyDateLimits = function($programType)
    {
        _.each(['#start_date'], function($id){
            $($id).datepicker('setStartDate', _.get($programType, 'min_start_at'));
            $($id).datepicker('setEndDate', _.get($programType, 'max_start_at'));
            if(_.get($programType, 'min_start_at')) {
                if(_.get($programType, 'min_start_at') === _.get($programType, 'max_start_at')) {
                    $($id).datepicker('setDate', _.get($programType, 'min_start_at'));
                }
            }
        });
    }

    /**
     * Are topics visible:
     * Either enabled, or present
     *
     * @return {Boolean}
     */
    $scope.areTopicsVisible = function() {
        return this.rule('allow_topic_selection') || this.hasTopics();
    }

    /**
     * True if the program has topics
     *
     * @return {Boolean}
     */
    $scope.hasTopics = function() {
        return _.get(this.program, 'presentation_topics', []).length > 0
    }

    /**
     * List Available topics
     *
     * @return collection
     */
    $scope.availableTopics = function() {
        if (this.program.id) {
            return this.rule('allow_topic_selection')
                 ? this.getPresentationTopics()
                 : this.program.presentation_topics
        }

        return this.getPresentationTopics();
    }

    /**
     * Watch the changes in our program
     *
     * @param  variable
     * @param  watcher method
     * @return void
     */
    $scope.$watchCollection(
        'program',
        function(newValue, oldValue) {
            /**
             * If we have changed the program type
             *
             * @return void
             */
            if (newValue.program_type !== oldValue.program_type) {
                /*  When the program type allows for the paren type */
                if ($scope.rule('parent_type_id')) {
                    /* Define scope*/
                    var query = {
                        'inType':$scope.rule('parent_type_id'),
                        'inBrand':newValue.primary_brand.id,
                        'inStatus[]':[7,8,9],
                        'visibilityScope':$scope.rule('parent_limited_to'),
                    }
                    /* get the parent type */
                    $scope.fetchParents(query)
                    /* There is a parent program BUT no id */
                } else if ($scope.program.parent_program && !$scope.program.id) {
                    /* Remove parent Program */
                    $scope.program.parent_program = null;
                }
            }

            /**
             * If we have changed the parent program and the rules state we need to copy dates
             * We would replicate tho
             *
             * @return void
             */
            if (newValue.parent_program !== oldValue.parent_program) {

                /* Replicate dates */
                if ($scope.rule('replicate_parent_dates')) {
                    $scope.program.start_date = newValue.parent_program.start_date
                    $scope.program.timezone_id = newValue.parent_program.timezone_id
                }

                /* Replicate parent Presentation */
                if ($scope.rule('replicate_parent_presentation')) {
                    var presentation = _.get(newValue, 'parent_program.primary_presentation.id');

                    if (presentation) {
                        $scope.program.presentation_id = presentation
                    }
                }
            }

            /**
             * We can only update program types when the program does ot exist, so
             * we are going to trigger the changes to the date scope
             */
            if (newValue.program_type !== oldValue.program_type) {
                // Apply rules.
                // see App\Http\Resources\Api\V2\Profile\CalculatesLeadTimes for the magic
                $scope.applyDateLimits(newValue.program_type)
            }
        }
    );
}]);
